<template>
	<div class="policyAdmin">
		<div class="policyAdminCon">
			
			<div class="head">
				<div class="left">
					<div class="title">
						政策管理
					</div>
					<div class="label">
						<div v-for="(item,index) of statusList" :key='index' class="li"
							:class="{active:selectStatus==item.status}" @click="changeStatus(item.status)">
							{{item.name}}
						</div>
					</div>
				</div>
				<el-button type="primary" @click="add">+发布新政策</el-button>
			</div>
			
			<div v-loading="loading" class="ul">
				<div class="nodata" v-if="list.length==0">
					<no-Data></no-Data>
				</div>
				<div v-for="(item,index) of list" :key="index" class="li">
					<div class="title">
						{{item.title}}
					</div>
					<div class="bottom">
						<div class="logoCon">
							<el-image :src="item.company.logo" fit="cover" class="logo"></el-image>
							<div class="right">
								<div class="name lineTextHidden">
									{{item.company.company_name}}
								</div>
								<div class="time">
									报名时间：{{item.application_start_date}}至{{item.application_end_date}}
								</div>
							</div>
						</div>
						<div class="num">
							<div class="numLi">
								{{item.application_limit?item.application_limit:'不限'}}名额
							</div>
							<div class="numLi">
								{{item.registered_count}}人已报
							</div>
						</div>
						<div class="status">
							<div class="dot" :style="{background:item.audit_status==3?'#FF6666':item.audit_status==1?'yellow':'#51A190'}"></div>
							<div>
								{{item.audit_status==1?'待审核':item.audit_status==2?'已通过':'平台驳回'}}
							</div>
						</div>
						<div class="status" v-if="item.audit_status==2">
							<div class="dot" :style="{background:item.status==2?'#FF6666':'#51A190'}"></div>
							<div>
								{{item.status==1?'开启':'关闭'}}
							</div>
						</div>
						<div class="controls" v-if="item.audit_status!=3">
							<div class="button" v-if="item.audit_status==2" style="color: #9B6CFF;" @click="rollCall(item.id)">报名名单</div>
							<div class="button" v-if="item.audit_status==1" style="color: #FF6666;"  @click="cancel(item.id)">撤销发布</div>
							<div class="button" v-if="item.audit_status==2" style="color: #9B6CFF;" @click="toSubsidy(item.id)">补贴管理</div>
							<div class="button" v-if="item.audit_status==2&&item.status==2" style="color: #51A190;" @click="stop(item.id,1)">开启</div>
							<div class="button" v-if="item.audit_status==2&&item.status==1" style="color: #FF6666;"  @click="stop(item.id,2)">停止</div>
						</div>
						<!-- <div v-else>
							驳回原因：
						</div> -->
					</div>
					<div class="remarks" v-if="item.audit_status==3">
						驳回原因：<span>{{item.audit_remarks}}</span>
					</div>
				</div>
			</div>
			
			
			<div v-if="total>limit" class="page">
				<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
					@current-change='changePage'>
				</el-pagination>
			</div>
		</div>
		
		<el-dialog title="提报政策补贴" :visible.sync="addShow" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
			<div v-loading="addLoading">
				<el-form label-width="98px" :model="form" :rules="rules" ref="uploadform">
					<el-form-item label="提报模板：" style="margin-bottom: 8px;">
						数据模板根据报名用户生成，
						<span style="color: #51A190;cursor: pointer;" @click="downloadTemplate()">点击下载提报模板</span>
					</el-form-item>
					<el-form-item label="上传文件：" prop="file">
						<div v-if="form.file" class="filebox" >
							<div><i class="el-icon-document"></i> {{form.file.name}}</div>
							<div class="reload" @click="handReload()">重新上传</div>
						</div>
						<div v-else class="uploadbox" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover" @click="$refs['upload-input'].click()">
							<input ref="upload-input" class="upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
							<i class="el-icon-upload uploadIcon"></i>
							<div>拖动文件至此处或<span style="color: #51A190;">点击上传</span></div>
						</div>
					</el-form-item>
				</el-form>
				
				<div style="text-align: center;margin-top: 28px;">
					<el-button size="medium" @click="addShow = false">取 消</el-button>
					<el-button size="medium" type="primary" @click="uploadFile()">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name:'policyAdmin',
		data() {
			var existFileRule = (rule, value, callback) => {
				if (!this.form.file) return callback(new Error('请上传提报文件'));
				callback();
			};
			return {
				selectStatus:1,
				statusList:[ 
					{ name:'待审核', status:1 },
					{ name:'已通过', status:2 },
					{ name:'被驳回', status:3 },
				],
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit: 10,
				addShow:false,
				addLoading:false,
				rules:{
					file: [{ required: true, validator: existFileRule, trigger: 'change' }],
				},
				form:{
					file:null,
				},
				addLoading:false,
				policy_id:'',
				policy_title:'',
			}
		},
		created() {
			this.getList()
		},
		methods: {
			downloadTemplate(){
				this.addLoading = true
				let data = {
					policy_id:this.policy_id,
					t:new Date().getTime()
				}
				this.$axios.get(`/api/client/ES/Policys/createPolicyExcel`,{params:data,responseType: 'blob'}).then(response => {
					if(response.type=='application/json'||response.type=='text/html'){
						const reader = new FileReader()
						reader.onload = ()=>{
							let msg = '下载模板失败';
							if(response.type == 'application/json') msg = JSON.parse(reader.result).msg;
							this.$eltips(msg,'error')
						}
						reader.readAsText(response)
						this.addLoading = false
						return
					}
					
					let blob = new Blob([response], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					if (window.navigator.msSaveOrOpenBlob) {
						//兼容ie
						window.navigator.msSaveBlob(blob, `补贴提报模板-${this.policy_title}`);
					} else {
						let downloadElement = document.createElement('a');
						let href = window.URL.createObjectURL(blob); //创建下载的链接
						downloadElement.href = href;
						downloadElement.download = `补贴提报模板-${this.policy_title}`; //下载后文件名
						document.body.appendChild(downloadElement);
						//此写法兼容火狐
						let evt = document.createEvent("MouseEvents");
						evt.initEvent("click", false, false);
						downloadElement.dispatchEvent(evt);
						document.body.removeChild(downloadElement);
					}
					this.addLoading = false
					this.$eltips('模板下载中','success')
				})
			},
			uploadFile(){
				this.$refs['uploadform'].validate((valid) => {
					if (!valid) return;
					let formData = new FormData();
					formData.append('file',this.form.file);
					formData.append('policy_id',this.policy_id);
					this.addLoading = true
					this.$axios.post('/api/client/ES/Policys/ImportPolicy',formData).then(res=>{
						this.addLoading = false
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.form.file = null
							this.addShow = false
							this.getList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				});
			},
			handReload(){
				this.form.file = null
				this.$nextTick(()=>{
					this.$refs['upload-input'].click()
				})
			},
			handleClick(e){
				if(e.target.files.length==0) return this.$refs['upload-input'].value = null;
				const file = e.target.files[0]
				if(!this.isExcel(file)) return eltips('仅支持 .xlsx, .xls 文件','error');
				this.form.file = file
				this.$refs['upload-input'].value = null
				this.$refs['uploadform'].validateField('file')
			},
			handleDrop(e) {
				e.stopPropagation()
				e.preventDefault()
				if (this.loading) return
				const files = e.dataTransfer.files
				if (files.length !== 1) return eltips('请上传单个文件', 'error');
				const file = files[0]
				if(!this.isExcel(file)) return eltips('仅支持 .xlsx, .xls 文件','error');
				this.form.file = file
				this.$refs['upload-input'].value = null
				this.$refs['uploadform'].validateField('file')
			},
			handleDragover(e) {
			  e.stopPropagation()
			  e.preventDefault()
			  e.dataTransfer.dropEffect = 'copy'
			},
			isExcel(file) {
			  return /\.(xlsx|xls|csv)$/.test(file.name)
			},
			toSubsidy(id){
				this.$router.push({ name: 'policySubsidy',query:{policy_id:id}});
			},
			getList(){
				this.loading = true
				let data={
					page: this.page,
					limit: this.limit,
					audit_status:this.selectStatus,
				}
				this.$axios.get('/api/client/ES/getMyPolicys', {params: data}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			add(){
				this.$router.push({ name: 'addPolicy'});
			},
			changeStatus(status){
				this.selectStatus=status
				this.page=1
				this.getList()
			},
			// 停用和启用
			stop(id,type){
				this.loading = true
				this.$axios.post('/api/client/ES/policyStop', {
					id: id,
					type:type
				}).then(res => {
					if (res.code == 200) {
						this.loading = false
						this.$eltips(type==1?'已启用':'已停用')
						this.getList()
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			},
			cancel(id){
				this.$confirm('此操作将撤销该政策，是否继续?', '撤销发布', {
					confirmButtonText: '确定撤销',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$axios.post('/api/client/ES/revokeMyPolicys', {
						id: id,
					}).then(res => {
						if (res.code == 200) {
							this.loading = false
							this.$eltips(res.msg)
							this.getList()
						} else {
							this.loading = false
							this.$eltips(res.msg, 'error')
						}
					})
				}).catch(() => {});
			},
			
			rollCall(id){
				this.$router.push({
					name: 'declareRoad',
					query: {
						id: id
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.policyAdmin{
		position: relative;
		padding: 24px 0;
		display: flex;
		justify-content: center;
		.policyAdminCon{
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.head{
				background-color: #FFF;
				margin-bottom: 16px;
				padding: 28px 38px 20px;
				border-radius: 16px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.title {
					color: #151515;
					font-size: 28px;
					font-weight: bold;
				}
				
				.label {
					display: flex;
					align-items: center;
					margin-top: 28px;
					.li {
						color: #151515;
						font-size: 18px;
						font-weight: bold;
						margin-right: 74px;
						cursor: pointer;
						&:hover {
							color: #51A190;
						}
					}
				
					.active {
						color: #51A190;
						position: relative;
						&::after {
							content: '';
							display: block;
							width: 20px;
							height: 4px;
							background-color: #9B6CFF;
							border-radius: 16px;
							bottom: -12px;
							left: 50%;
							position: absolute;
							transform: translate(-50%, 0);
						}
					}
				}
			}
			
			.page {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 28px 0 0;
			}
		
		    .ul{
				min-height: 400px;
				.nodata{
					height: 400px;
					background: #FFFFFF;
					border-radius: 16px;
				}
				.li{
					padding: 18px 38px;
					background-color: #FFF;
					border-radius: 16px;
					margin-bottom: 20px;
					&:last-child{
						margin-bottom: 0;
					}
					.title{
						color: #151515;
						font-size: 20px;
						margin-bottom: 18px;
					}
					.bottom{
						display: flex;
						align-items: center;
						justify-content: space-between;
						.logoCon{
							display: flex;
							align-items: center;
							flex: 0 0 338px;
							.logo{
								width: 70px;
								height: 70px;
								margin-right: 18px;
								border-radius: 8px;
							}
							.right{
								width: 250px;
								.name{
									width: 250px;
									color: #151515;
									font-size: 16px;
									margin-bottom: 17px;
								}
								.time{
									color: #5E5E5E;
									font-size: 14px;
								}
							}
						}
						.num{
							color: #5E5E5E;
							font-size: 14px;
							display: flex;
							align-items: center;
							.numLi{
								padding: 0 16px;
								&:last-child{
									border-left: 1px solid #D3D6DB;
								}
							}
						}
						.status{
							display: flex;
							align-items: center;
							font-size: 16px;
							.dot{
								width: 12px;
								height: 12px;
								border-radius: 50%;
								background-color: #51A190;
								margin-right: 6px;
							}
							color: #151515;
						}
						.controls{
							display: flex;
							align-items: center;
							margin-left: 30px;
							.button{
								margin-right: 18px;
								font-size: 16px;
								cursor: pointer;
								&:last-child{
									margin-right: 0;
								}
							}
						}
					}
					.remarks{
						margin-top: 18px;
						text-align: justify;
						span{
							color: #F44;
						}
					}
				}
			}
		}
	
		.filebox{
			display: flex;
			align-items: center;
			justify-content: space-between;
			.reload{
				line-height: 1;
				color: #51A190;
				cursor: pointer;
			}
		}
		
		.uploadbox{
			width: 100%;
			height: 200px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			&:hover{
				border-color: #51A190;
				border-style: dashed;
			}
			.uploadIcon{
				font-size: 68px;
				color: #c0c4cc;
				line-height: 1;
				margin-bottom: 12px;
			}
			.upload-input{
			  display: none;
			  z-index: -9999;
			}
		}
	}
</style>